import { isEmpty } from '@helpers/data'
import { parseDateString } from '@helpers/date'
import { getCard } from '@helpers/getCard'

export const isCardNumberHasProperLength = (cardNumber: string) =>
  cardNumber.length < 18 || cardNumber.length > 19

export const isCardSupported = (cardNumber: string) =>
  !isEmpty(getCard(cardNumber))

export const isCorrectCardExpiration = (cardExpiry: string) => {
  const expiryDate = new Date(parseDateString('', cardExpiry))

  return Number.isNaN(expiryDate.getTime()) || expiryDate < new Date()
}

export const isCvcValid = (cardCvv: string, cardNumber?: string) => {
  const card = cardNumber && getCard(cardNumber)

  const expectedCvvLength = card ? card.cvvLength : 3

  return cardCvv.length === expectedCvvLength
}
